export default __webpack_public_path__ + "static/media/bills.2d6f2e0c.svg";